import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  download: {
    id: 'studio.j161zh',
    defaultMessage: 'Download {filename}',
  },
  copy: {
    id: 'studio.aCdAsI',
    defaultMessage: 'Copy to clipboard',
  },
  copySuccess: {
    id: 'studio.8bhBiJ',
    defaultMessage: 'Copied the code to clipboard successfully',
  },
  copyError: {
    id: 'studio.qClp9t',
    defaultMessage: 'There was a problem copying the code sample',
  },
});
